<template>
  <svg
    class="alert-red-dot"
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="6.97656"
      cy="6"
      r="5"
      fill="#FA0000"
      stroke="white"
      stroke-width="2"
    />
  </svg>
</template>

<script>
export default {
  name: "alert-badge",
}
</script>

<style scoped>
.alert-red-dot {
  margin-bottom: 12px;
}
</style>
